package nl.volleyplanner.util

import kotlinx.serialization.KSerializer
import kotlinx.serialization.descriptors.PrimitiveKind
import kotlinx.serialization.descriptors.PrimitiveSerialDescriptor
import kotlinx.serialization.encoding.Decoder
import kotlinx.serialization.encoding.Encoder


open class ObjectToStringSerializer<T>(
    private val serialName: String,
    private val toStringFunction: (T) -> String,
    private val toObjectFunction: (String) -> T
) : KSerializer<T> {
    override val descriptor = PrimitiveSerialDescriptor(serialName, PrimitiveKind.STRING)

    override fun deserialize(decoder: Decoder): T {
        return toObjectFunction(decoder.decodeString())
    }

    override fun serialize(encoder: Encoder, value: T) {
        encoder.encodeString(toStringFunction(value))
    }
}

fun <T> objectToStringSerializer(serialName: String, serializer: (T) -> String, deserializer: (String) -> T): KSerializer<T> = ObjectToStringSerializer(serialName, serializer, deserializer)
